export const environment = {
  production: true,
 version: '9.5.16.5',
  SWAapiEnvMode: 'ProdMode'
};
